module.exports = __webpack_public_path__ + "static/media/logo-kimlikbasit.b88ed985.svg";